module.exports = __webpack_public_path__ + "static/media/github-actions.58fdde39.png";